import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';
import { SET_RECEIVE_LEADERBOARDS } from '../../utils/common/constant';

const ActionType = {
  SET_RECEIVE_LEADERBOARDS,
};

const receiveLeaderboardsActionCreator = (leaderboards) => {
  return {
    type: ActionType.SET_RECEIVE_LEADERBOARDS,
    payload: {
      leaderboards,
    },
  };
};

const asyncReceiveLeaderboard = () => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const leaderboard = await api.getAllLeaderboards();
      dispatch(receiveLeaderboardsActionCreator(leaderboard));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  receiveLeaderboardsActionCreator,
  asyncReceiveLeaderboard,
};
